webpackJsonp([2],{

/***/ 104:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [_vm.rootCss],
    style: (_vm.rootStyle)
  }, [(_vm.loading) ? _c('table', {
    class: [(_vm.rootCss + "-grid")],
    style: (_vm.style),
    attrs: {
      "id": _vm.id
    }
  }, [(_vm.title || _vm.description) ? _c('tr', [_c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": _vm.setup.strings.length
    }
  }, [(_vm.title) ? _c('h5', {
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.description) ? _c('h6', {
    domProps: {
      "innerHTML": _vm._s(_vm.description)
    }
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.notes) ? _c('tr', {
    class: [(_vm.rootCss + "-small-caps"), (_vm.rootCss + "-notes"), (_vm.rootCss + "-greyed-out")]
  }, [_c('td'), _vm._v(" "), _vm._l((_vm.setup.tuning), function(key) {
    return _c('td', [_vm._v(_vm._s(key))])
  })], 2) : _vm._e(), _vm._v(" "), _vm._l((_vm.frets), function(fret, index) {
    return _c('tr', {
      key: index,
      class: [(_vm.rootCss + "-small-caps"), (_vm.rootCss + "-neck")]
    }, [_c('td', {
      class: ['vc-chord-diagram-position', (_vm.rootCss + "-greyed-out")]
    }, [(_vm.position) ? _c('div', [_vm._v(_vm._s(_vm.romanize(_vm.setup.startAt + index)))]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.setup.strings), function(string) {
      return _c('td', {
        style: ({
          borderBottomColor: ("" + _vm.color)
        })
      }, [_c('div', [(string.fret === fret) ? _c('div', {
        class: [(_vm.rootCss + "-finger")],
        style: (_vm.dot)
      }) : _c('div', {
        class: [(_vm.rootCss + "-finger")],
        style: (_vm.empty)
      })]), _vm._v(" "), _c('div', {
        style: ({
          background: _vm.color
        })
      })])
    })], 2)
  }), _vm._v(" "), (_vm.fingers) ? _c('tr', {
    class: [(_vm.rootCss + "-fingers"), (_vm.rootCss + "-small-caps"), (_vm.rootCss + "-greyed-out")]
  }, [_c('td'), _vm._v(" "), _vm._l((_vm.setup.strings), function(string) {
    return _c('td', {
      domProps: {
        "innerHTML": _vm._s(string.finger)
      }
    })
  })], 2) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.canvas) ? _c('img', {
    style: (_vm.style),
    attrs: {
      "src": _vm.src
    },
    on: {
      "load": _vm.ready
    }
  }) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 26:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(92)
}
var Component = __webpack_require__(44)(
  /* script */
  __webpack_require__(53),
  /* template */
  __webpack_require__(104),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 50:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_vc_chord_diagram_index__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_vc_chord_diagram_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_vc_chord_diagram_index__);


/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__components_vc_chord_diagram_index___default.a);

/***/ }),

/***/ 53:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_html_to_image__ = __webpack_require__(100);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'VcChordDiagram',
  data: function data() {
    return {
      rootCss: 'vc-chord-diagram',
      rootStyle: {
        font: 'normal normal .9em Avenir, Roboto, Helvetica, sans-serif'
      },
      frets: 0,
      id: null,
      loading: true,
      src: ''
    };
  },

  props: {
    /**
     * Render as an image instead as html
     * */
    canvas: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * Diagram setup
     * */
    setup: {
      type: Object,
      required: true
    },
    /**
     * Diagram title
     * */
    title: {
      type: String,
      required: false
    },
    /**
     * Diagram description
     * */
    description: {
      type: String,
      required: false
    },
    /**
     * Show the fingers bar
     * */
    fingers: {
      type: Boolean,
      required: false,
      default: true
    },
    /**
     * Width of the diagram in pixels or percentage
     * */
    width: {
      type: String,
      required: false,
      default: '100px'
    },
    /**
     * Height of the diagram in pixels
     * */
    height: {
      type: String,
      required: false,
      default: '160px'
    },
    /**
     * Show the notes bar
     * */
    notes: {
      type: Boolean,
      required: false,
      default: true
    },
    /**
     * Show the position bar
     * */
    position: {
      type: Boolean,
      required: false,
      default: true
    },
    /**
     * Diagram color
     * */
    color: {
      type: String,
      required: false,
      default: '#000'
    },
    /**
     * Diagram background color
     * */
    bgColor: {
      type: String,
      required: false,
      default: '#fff'
    },
    /**
     * Size of the finger dot
     * */
    dotSize: {
      type: Number,
      required: false,
      default: 10
    }
  },
  computed: {
    /**
     * Box styles
     * @computed style
     * @return {Object}
     * */
    style: function style() {
      return {
        width: this.width,
        height: this.height,
        color: this.color,
        background: this.bgColor
      };
    },

    /**
     * Finger dot styles
     * @computed dot
     * @return {Object}
     * */
    dot: function dot() {
      return {
        background: this.color,
        width: this.dotSize + 'px',
        height: this.dotSize + 'px'
      };
    },

    /**
     * Empty position styles
     * @computed empty
     * @return {Object}
     * */
    empty: function empty() {
      return {
        background: null,
        width: this.dotSize + 'px',
        height: this.dotSize + 'px'
      };
    }
  },
  mounted: function mounted() {
    var _this = this;

    var positions = [];
    this.setup.strings.forEach(function (string) {
      var fret = string.fret;
      if (!positions.includes(fret)) {
        positions.push(fret);
      }
    });
    this.frets = positions.length;
    if (this.canvas) {
      this.id = this.guid();
      this.$nextTick(function () {
        var node = _this.id;
        __WEBPACK_IMPORTED_MODULE_0_html_to_image__["a" /* default */].toSvgDataURL(document.getElementById(node), {
          style: {
            font: _this.rootStyle.font,
            width: _this.width,
            height: _this.height
          }
        }).then(function (dataUrl) {
          _this.src = dataUrl;
        });
      });
    }
  },

  methods: {
    /**
     * Ready callback
     * @method ready
     * @return void
     * */
    ready: function ready() {
      this.loading = false;
    },

    /**
     * Create a UUID/GUID
     * @method guid
     * @return {String}
     * */
    guid: function guid() {
      function s4() {
        return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
      }
      return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
    },

    /**
     * Romanize Arabic numbers
     * @method romanize
     * @return {String}
     * */
    romanize: function romanize(num) {
      if (!+num) {
        return NaN;
      }
      var digits = String(+num).split('');
      var key = ['', 'C', 'CC', 'CCC', 'CD', 'D', 'DC', 'DCC', 'DCCC', 'CM', '', 'X', 'XX', 'XXX', 'XL', 'L', 'LX', 'LXX', 'LXXX', 'XC', '', 'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX'];
      var roman = '';
      var i = 3;
      while (i--) {
        roman = (key[+digits.pop() + i * 10] || '') + roman;
        return Array(+digits.join('') + 1).join('M') + roman;
      }
    }
  }
});

/***/ }),

/***/ 92:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[50]);


// WEBPACK FOOTER //
// docs/js/vc-chord-diagram.695eeb02e4eecfa7f8e0.js